import { Moment } from 'moment';
import { Severity } from '../../../../common/enums/Severity';
import { InventoryRecap } from '../../../../common/inventory/models/InventoryRecap';
import { Profile } from '../../../../common/models/Profile';
import { Preset } from '../../../../common/models/valueObjects/Preset';
import { CallLimiting } from '../../../../common/reports/models/CallLimiting';
import { Coverage } from '../../../../common/reports/models/Coverage';
import { JavaProvider } from '../../../../common/reports/models/JavaProvider';
import { ObjectStat } from '../../../../common/reports/models/ObjectStat';
import { InstancesCounters } from './valueObjects/InstancesCounters';
import { Issue } from './valueObjects/Issue';

export class ReportPrintData {
  private issueGroups: Record<Severity, Issue[]>;

  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly generatedAt: Moment,
    private readonly completedAt: Moment,
    private readonly trace: Preset | null,
    private readonly project: Preset | null,
    private readonly profile: Profile | null,
    private readonly issues: Issue[] | null,
    private readonly inventory: InventoryRecap | null,
    private readonly stats: ObjectStat[],
    private readonly nonsensitiveSalt: string | null,
    private readonly coverage: Coverage | null,
    private readonly callLimiting: CallLimiting | null,
    private readonly instancesCounters: InstancesCounters | null,
    private readonly javaProviders: JavaProvider[]
  ) {
    this.issueGroups = {
      [Severity.HIGH]: [],
      [Severity.MED]: [],
      [Severity.LOW]: [],
      [Severity.PASSED]: [],
      [Severity.FILTERED]: [],
      [Severity.DISABLED]: [],
      [Severity.NA]: [],
      [Severity.NO_WARNING]: [],
    };
    for (const issue of this.issues ?? []) {
      this.issueGroups[issue.getSeverity()].push(issue);
    }
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getGeneratedAt() {
    return this.generatedAt;
  }

  getCompletedAt() {
    return this.completedAt;
  }

  getTrace() {
    return this.trace;
  }

  getProject() {
    return this.project;
  }

  getProfile() {
    return this.profile;
  }

  getInventory() {
    return this.inventory;
  }

  getIssueGroups() {
    return this.issueGroups;
  }

  hasPriorityIssues() {
    return [Severity.PASSED, Severity.LOW, Severity.MED, Severity.HIGH].some((s) => this.issueGroups[s].length > 0);
  }

  hasHiddenIssues() {
    return [Severity.DISABLED, Severity.FILTERED, Severity.NA, Severity.NO_WARNING].some((s) => this.issueGroups[s].length > 0);
  }

  getStats() {
    return this.stats;
  }

  getNonsensitiveSalt() {
    return this.nonsensitiveSalt;
  }

  getCoverage() {
    return this.coverage;
  }

  getCallLimiting() {
    return this.callLimiting;
  }

  getInstancesCounters() {
    return this.instancesCounters;
  }

  getJavaProviders() {
    return this.javaProviders;
  }
}
